import { useEffect, useState } from "react";
import LogoDark from "../assets/logoDark.png";
import LogoLight from "../assets/logoLight.png";
import { prefersDarkMode, addColorSchemeListener } from "../utils/theme";

interface ThemeAwareLogoProps {
  className?: string;
}

export default function ThemeAwareLogo({
  className = "h-8 w-auto",
}: ThemeAwareLogoProps) {
  const [isDarkMode, setIsDarkMode] = useState(prefersDarkMode());

  useEffect(() => {
    // Set up listener for theme changes
    const removeListener = addColorSchemeListener((isDark) => {
      setIsDarkMode(isDark);
    });

    // Clean up listener on component unmount
    return removeListener;
  }, []);

  // Use light logo (red) for light mode, dark logo (white) for dark mode
  const logoSrc = isDarkMode ? LogoDark : LogoLight;

  return (
    <div className="flex items-center justify-center">
      <img
        src={logoSrc}
        alt="Kitra Logo"
        className={`${className} object-contain`}
      />
    </div>
  );
}
